export default __webpack_public_path__ + "static/media/left-arrow.2e22e7a8.svg";